// extracted by mini-css-extract-plugin
module.exports = {"page":"page__-Lu08"};